module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAUBAMAAAAevyJ8AAAAGFBMVEVKrdZLrdVcssCSwIHJ0EDS0Tbt2RX/3gAfmmgCAAAAP0lEQVQY02NgoBYQdksxROYzhZeXlyogCYiWA0EgkoA5SKAYScAdJFCCJJAOEijDJ4ChBcNQDGsxHIbhdAoBADNTGcXM+PqYAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/pw.png
// module id = 367
// module chunks = 0